// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"605":"5f677627","1979":"38512ed5","7056":"38512ed5","8016":"38512ed5"}[chunkId] + ".chunk.css";
};